document.addEventListener('DOMContentLoaded', function () {
  // Dawn auto-generates a "Shipping" link inside the product tax/shipping
  // caption that points straight to /policies/shipping-policy. FBS wants
  // that to open the Shipping & Returns modal instead of leaving the PDP.
  var shippingLink = document.querySelector('.product__tax a[href*="/policies/shipping-policy"]');
  var modalTriggerButton = document.getElementById('ProductPopup-shipping_returns_popup');

  if (shippingLink && modalTriggerButton) {
    shippingLink.setAttribute('role', 'button');
    shippingLink.addEventListener('click', function (event) {
      event.preventDefault();
      modalTriggerButton.click();
    });
  }

  // The Shipping & Returns popup block's "page" setting isn't resolving
  // to the actual page content (a Shopify theme-editor/API quirk with
  // page-picker settings on this block). Rather than keep guessing at
  // the setting's serialization format, inject the real content directly
  // so the modal reliably shows something instead of a blank black box.
  var modalInfo = document.querySelector('#PopupModal-shipping_returns_popup .product-popup-modal__content-info');
  if (modalInfo && !modalInfo.querySelector('p')) {
    var heading = modalInfo.querySelector('h1');
    if (heading) {
      heading.textContent = 'Shipping & Returns';
    }
    var body = document.createElement('div');
    body.innerHTML = '<p><strong>Shipping</strong></p>' +
      '<ul>' +
      '<li>In-stock items (parts, collectibles, apparel) ship within 1 business day.</li>' +
      '<li>Custom/made-to-order apparel ships in 7–10 business days.</li>' +
      '<li>Vehicles aren\'t shipped — pickup or transport is arranged directly with the buyer.</li>' +
      '<li>We ship within the United States only.</li>' +
      '<li>Larger or oversized items may require freight (LTL) shipping — we\'ll reach out with a quote before your order ships if that applies.</li>' +
      '</ul>' +
      '<p><strong>Returns</strong></p>' +
      '<ul>' +
      '<li>Our inventory is vintage, used, and one-of-a-kind — all sales are final, sold as-is based on the listing\'s description and photos.</li>' +
      '<li>Item arrived damaged, or you received the wrong item? Contact us within 7 days of delivery and we\'ll make it right.</li>' +
      '<li>Review all photos carefully and ask questions before buying — photos are part of the description.</li>' +
      '</ul>' +
      '<p><a class="link underlined-link" href="/policies/shipping-policy">Full Shipping Policy</a> &nbsp;|&nbsp; <a class="link underlined-link" href="/policies/refund-policy">Full Return &amp; Refund Policy</a></p>';
    modalInfo.appendChild(body);
  }
});
